import { useQuery } from 'react-query';

import { ErrorResponse } from 'api/types/errors';
import {
  verifyMembershipCode,
  VerifyMembershipCodeResponse
} from 'api/services/organizations/memberships-discount';

export function useVerifyMembershipCode(
  organizationId: string,
  code: string | null,
  options = {}
) {
  return useQuery<VerifyMembershipCodeResponse, ErrorResponse>(
    ['memberships/verifyCode', organizationId, code],
    () => verifyMembershipCode(organizationId, code),
    { enabled: code?.length > 0, retry: 0, ...options }
  );
}
